import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './navbar.css';

const Navbar = () => {

  const [showForm, setShowForm] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData(e.target);

    await fetch("https://formsubmit.co/ajax/info@wecanserve.com", {
      method: "POST",
      body: data
    });

    setShowForm(false);
    alert("Thanks! We'll get back to you.");
  };

  return (
    <>

      {/* NAVBAR */}
      <nav className="navbar">

        {/* LOGO */}
        <div className="nav-logo">
          <NavLink to="/">
            <img src="/wcs-logo.png" alt="WCS Logo" />
          </NavLink>
        </div>

        {/* DESKTOP NAV */}
        <ul className="nav-links">

          <li>
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              Home
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              About Us
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/services"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              Services
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/portfolio"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              Portfolio
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              Contact Us
            </NavLink>
          </li>

        </ul>

        {/* CTA */}
        <div className="nav-cta">
          <button
            className="btn-nav-talk"
            onClick={() => setShowForm(true)}
          >
            Let's Talk →
          </button>
        </div>

      </nav>

      {/* HAMBURGER ICON */}
      <div
        className="hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? '✕' : '☰'}
      </div>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${menuOpen ? 'show' : ''}`}>

        <NavLink
          to="/"
          onClick={() => setMenuOpen(false)}
        >
          Home
        </NavLink>

        <NavLink
          to="/about"
          onClick={() => setMenuOpen(false)}
        >
          About Us
        </NavLink>

        <NavLink
          to="/services"
          onClick={() => setMenuOpen(false)}
        >
          Services
        </NavLink>

        <NavLink
          to="/portfolio"
          onClick={() => setMenuOpen(false)}
        >
          Portfolio
        </NavLink>

        <NavLink
          to="/contact"
          onClick={() => setMenuOpen(false)}
        >
          Contact Us
        </NavLink>

        <button
          className="mobile-talk-btn"
          onClick={() => {
            setShowForm(true);
            setMenuOpen(false);
          }}
        >
          Let's Talk →
        </button>

      </div>

      {/* MODAL */}
      {showForm && (

        <div
          className="modal-overlay"
          onClick={() => setShowForm(false)}
        >

          <div
            className="modal-box"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="modal-header">

              <h3>Start a Conversation</h3>

              <span
                className="close-btn"
                onClick={() => setShowForm(false)}
              >
                ✕
              </span>

            </div>

            <form
              onSubmit={handleSubmit}
              className="modal-form"
            >

              <input
                type="hidden"
                name="_captcha"
                value="false"
              />

              <input
                type="text"
                name="name"
                placeholder="Full Name"
                required
              />

              <input
                type="tel"
                name="phone"
                placeholder="Mobile Number (Optional)"
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                required
              />

              <select name="service" required>

                <option value="">
                  Interested Service
                </option>

                <option value="Website Development">
                  Website Development
                </option>

                <option value="Social Media Marketing">
                  Social Media Marketing
                </option>

                <option value="Performance Marketing">
                  Performance Marketing
                </option>

                <option value="SEO Services">
                  SEO Services
                </option>

                <option value="Branding & Positioning">
                  Branding & Positioning
                </option>

                <option value="Content Creation">
                  Content Creation
                </option>

                <option value="PR & Media Coverage">
                  PR & Media Coverage
                </option>

                <option value="AI Automation Solutions">
                  AI Automation Solutions
                </option>

                <option value="Other">
                  Other
                </option>

              </select>

              <textarea
                name="message"
                placeholder="Tell us about your requirement..."
                required
              />

              <button
                type="submit"
                className="btn-send"
              >
                Submit
              </button>

            </form>

          </div>

        </div>

      )}

    </>
  );
};

export default Navbar;